'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';

import { cn } from '#/lib/utils';
import { ROUTES } from '#/data/constants';
import { trackEvent } from '#/lib/analytics';
import { useLocale, useT } from '#/i18n/client';
import { localizePath } from '#/i18n/config';

/**
 * 모바일 헤더의 진입점. MainNav 가 `hidden md:flex` 라 좁은 화면에서는 통째로
 * 숨는데, 그러면 남는 건 로고와 햄버거뿐이라 기능을 알 길이 없다. 종전에
 * 이 자리를 차지하던 '바른' 글자를 대신한다(브랜드는 로고가 이미 말한다).
 */
export function MobileCorrectLink() {
  const pathname = usePathname() ?? '';
  const locale = useLocale();
  const t = useT('common');

  return (
    <Link
      href={localizePath(ROUTES.CORRECT, locale)}
      onClick={() =>
        trackEvent('click_other_menu', {
          location: 'header_nav_mobile',
          from: pathname,
          to: ROUTES.CORRECT,
          label: '맞춤법 검사'
        })
      }
      className={cn(
        'md:hidden ml-3 whitespace-nowrap rounded-full px-3 py-1.5',
        'text-sm font-semibold transition-colors',
        'bg-[#104573] text-white hover:bg-[#0b3357]',
        'dark:bg-[#60a3d9] dark:text-[#0c1a2e] dark:hover:bg-[#8dbfe6]'
      )}
    >
      {t('nav.spellCheck')}
    </Link>
  );
}
